module.exports = __webpack_public_path__ + "img/done-icon.623b2577.svg";